import React, { Component } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import qs from 'query-string';
import { orderByCode } from './helpers';
import { Checkbox } from '../../forms';
import MapImage from '../../../images/map.png';
import './geography.scss';
import './styles.scss';

class WrappedCheckbox extends Component {
    state = {
        checked: this.isDefaultChecked()
    }

    isDefaultChecked() {
        const { query, value } = this.props;
        return query && query[this.props.name] && query[this.props.name].indexOf(value) > -1;
    }

    handleChange() {
        if (this.props.count === 0 && this.state.checked) return;

        this.setState({
            checked: !this.state.checked
        }, () => {
            this.props.onChange();    
        });
    }

    render () {
        return (
            <label className={classNames({
                        'facet-item': true,
                        'facet-item--is-visible': this.props.count > 0,
                        'facet-item--is-disabled': this.props.count === 0 && this.state.checked
                    })}>
                <Checkbox name={this.props.name} value={this.props.value} onChange={() => this.handleChange()} checked={this.state.checked} />
                {this.props.children}
            </label>
        );
    }
}

class Geography extends Component {
    aregionnames = [];
    state = {
        tab: 'region',
        municipality: [{
            facetValues: []
        }],
        aregion: [{
            facetValues: [] 
        }],
        visitingcity: [{
            facetValues: []
        }]
    };

    toggleTab(e, tab) {
        e.preventDefault();
        this.setState({
            tab
        });
    }

    isOpen(tab) {
        return this.props.isOpen && this.state.tab === tab;
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps && (prevProps.municipality !== this.props.municipality || prevProps.aregion !== this.props.aregion)) {
            
            const hasMoreMunicipalityFacets = (this.props.municipality && this.props.municipality[0].facetValues.filter(item => item.count > 0).length) > (this.state.municipality && this.state.municipality[0].facetValues.filter(item => item.count > 0).length);
            const hasMoreAregionFacets = (this.props.aregion && this.props.aregion[0].facetValues.filter(item => item.count > 0).length) > (this.state.aregion && this.state.aregion[0].facetValues.filter(item => item.count > 0).length);
            const hasMoreVisitingcityFacets = (this.props.visitingcity && this.props.visitingcity[0].facetValues.filter(item => item.count > 0).length) > (this.state.visitingcity && this.state.visitingcity[0].facetValues.filter(item => item.count > 0).length);

            this.setState({
                municipality: hasMoreMunicipalityFacets || !this.isOpen('county') ? this.props.municipality : this.state.municipality,
                aregion: hasMoreAregionFacets || !this.isOpen('region') ? this.props.aregion : this.state.aregion,
                visitingcity: hasMoreVisitingcityFacets || !this.isOpen('city') ? this.props.visitingcity : this.state.visitingcity
            });
        }
    }

    render() {

        const { submitForm, location: { search } } = this.props;
        const { municipality, aregion, visitingcity } = this.state;
        const query = qs.parse(search);

        return (
            <div className="geography">
                <ul className="geography__tabs">
                    <li className={classNames({
                        'geography__tabs-item': true,
                        'geography__tabs-item--is-selected': this.state.tab === 'region'
                    })}>
                        <a onClick={(e) => this.toggleTab(e, 'region')} href="#region">A-region</a>
                    </li>
                    <li className={classNames({
                        'geography__tabs-item': true,
                        'geography__tabs-item--is-selected': this.state.tab === 'county'
                    })}>
                        <a onClick={(e) => this.toggleTab(e, 'county')} href="#county">Kommun</a>
                    </li>
                    <li className={classNames({
                        'geography__tabs-item': true,
                        'geography__tabs-item--is-selected': this.state.tab === 'city'
                    })}>
                        <a onClick={(e) => this.toggleTab(e, 'city')} href="#county">Ort</a>
                    </li>
                </ul>
                <div id="region" className={classNames({
                        'geography__tab': true,
                        'geography__tab--is-active': this.state.tab === 'region'
                    })}>
                    <div className="geography__inner">
                        <div className="geography__region">
                            <div className="geography__region-col">
                                {aregion && aregion[0] && orderByCode(aregion[0].facetValues).map(((m, i) => {
                                    return (                                    
                                        <WrappedCheckbox key={`municipality${m.label}`} name="aregionname" value={m.label} count={m.count} onChange={() => submitForm()} query={query}> 
                                            <>
                                                <span>{m.code} - {m.label}</span>
                                                <span className="facet-item__count">{m.count}st</span>
                                            </>
                                        </WrappedCheckbox>
                                    );
                                }))}
                            </div>
                            <div className="geography__region-col">
                                <img src={MapImage} alt="Karta med regioner" />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="county" className={classNames({
                        'geography__tab': true,
                        'geography__tab--is-active': this.state.tab === 'county'
                    })}>
                    <div className="geography__inner">
                        <div className="geography__county">
                            {municipality && municipality[0] && municipality[0].facetValues.map(((m, i) => {
                                return (
                                    <WrappedCheckbox key={`municipality${m.label}`} count={m.count} name="municipalityname" value={m.label} onChange={() => submitForm()} query={query}> 
                                        <>
                                            <span>{m.label}</span>
                                            <span className="facet-item__count">{m.count}st</span>
                                        </>
                                    </WrappedCheckbox>
                                );
                            }))}
                        </div>
                    </div>
                </div>
                <div id="city" className={classNames({
                        'geography__tab': true,
                        'geography__tab--is-active': this.state.tab === 'city'
                    })}>
                    <div className="geography__inner">
                        <div className="geography__county">
                            {visitingcity && visitingcity[0] && visitingcity[0].facetValues.map(((m, i) => {
                                return (
                                    <WrappedCheckbox key={`city${m.label}`} count={m.count} name="visitingcity" value={m.label} onChange={() => submitForm()} query={query}> 
                                        <>
                                            <span>{m.label}</span>
                                            <span className="facet-item__count">{m.count}st</span>
                                        </>
                                    </WrappedCheckbox>
                                );
                            }))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default withRouter(Geography);